__turbopack_context__.v({
  "icon": "r1zDQq_icon",
  "link": "r1zDQq_link",
  "svg": "r1zDQq_svg",
  "wrapper": "r1zDQq_wrapper",
});
